<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-页面目录-修改
    -->
    <el-dialog
    title="修改页面目录"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改页面目录</div>
      
      <el-form-item label="页面目录名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入页面目录名称" class="max-w460"></el-input>
      </el-form-item>
      
      <!-- 简介改为输入框 -->
      <el-form-item label="简介">
        <el-input 
          v-model="form.detail" 
          type="textarea" 
          :rows="3" 
          placeholder="请输入简介" 
          class="max-w460"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>

      <!-- 详情保持为富文本 -->
       <el-form-item label="介绍">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  
      
      <!-- 图片上传区域 -->
      <el-form-item label="目录图片" prop="image">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.image" @change="onImageListChange">
            <transition-group name="fade-list">
              <div v-for="(item, index) in form.image" :key="item.file_id || index" class="image-item-container">
                <div class="item">
                  <img v-img-url="item.file_path" alt="图片预览" class="image-preview"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImage(index)">
                    <i class="el-icon-close"></i>
                  </a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openImageUpload">
            <i class="el-icon-plus"></i>
            <div class="upload-text">添加图片</div>
          </div>
        </div>
        <div class="form-hint">支持上传JPG、PNG、GIF等格式图片，建议尺寸300x300px，单个文件不超过2MB</div>
      </el-form-item>

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>
       
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

    <!-- 图片上传组件 -->
    <Upload 
      v-if="isProductUpload" 
      :config="uploadConfig" 
      :isupload="isProductUpload" 
      @returnImgs="returnProductImgsFunc"
      @close="isProductUpload = false"
    >
      上传图片
    </Upload>
  </div>
</el-dialog>
</template>

<script>
import StudymenuApi from '@/api/studymenu.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
    Upload,
    Categoryas,
    draggable,
    Uediter
  },
  data() {
    return {
      /*是否上传图片*/
      isProductUpload: false,
      uploadConfig: {
        total: 1, // 限制上传1张图片
        accept: 'image/*',
        size: 2097152  // 2MB
      },
      
      /*富文本配置 - 只保留详情富文本配置*/
       ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image: [], // 图片数组
        sort: 50,
        intro: "", // 简介（输入框）
        detail: "" // 详情（富文本）
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入页面目录名称', trigger: 'blur' }],
        image: [{ required: false, message: '请上传目录图片', trigger: 'change' }],
        intro: [{ required: false, message: '请输入简介', trigger: 'blur' }],
        detail: [{ required: false, message: '请输入详情', trigger: 'blur' }]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: []
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add", "studymenu_id"],
  methods: {
    chooseCategory() {
      this.iscategorya = true;
    },
    
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    
    cancelFunc() { // 取消
      this.dialogFormVisible("error")
    },
    
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      StudymenuApi.detail({ studymenu_id: self.studymenu_id }, true).then(res => {
            self.form = res.data;
        self.ueditor.text = self.form.intro;
        self.isImg = true;
        self.loading = false;
      
      }).catch(error => {});
    },
    
    onSubmit() {
      let self = this;
      let form = self.form;
      
      // 只获取详情富文本内容（简介现在是输入框，直接使用v-model绑定的值）
      form.intro = this.$refs.ue.getUEContent();
      
      form.studymenu_id = self.studymenu_id;
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          StudymenuApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("success");
            })
            .catch(error => {
              self.loading = false;
              console.error('修改失败:', error);
            });
        }
      });
    },

    /*打开图片上传*/
    openImageUpload() {
      this.isProductUpload = true;
    },

    /*处理上传的图片*/
    returnProductImgsFunc(files) {
      if (!files || files.length === 0) {
        this.isProductUpload = false;
        return;
      }
      
      // 验证图片类型和大小
      const isValid = this.validateImages(files);
      if (!isValid) {
        return;
      }
      
      // 由于限制上传1张图片，这里替换原有图片
      this.$set(this.form, "image", files.slice(0, 1));
      this.isProductUpload = false;
    },

    /*验证图片类型和大小*/
    validateImages(files) {
      const imgTypes = ["bmp", "jpg", "jpeg", "png", "gif"];
      
      for (const file of files) {
        // 获取文件扩展名
        const ext = this.getFileExtension(file.file_path).toLowerCase();
        
        // 验证图片类型
        if (!imgTypes.includes(ext)) {
          this.$message.error("图片类型有误，请选择bmp、jpg、jpeg、png、gif格式");
          return false;
        }
        
        // 验证图片大小
        if (file.size && file.size > 2097152) { // 2MB
          this.$message.error("图片大小不能超过2MB");
          return false;
        }
      }
      
      return true;
    },

    /*删除图片*/
    deleteImage(index) {
      this.form.image.splice(index, 1);
    },

    /*获取文件扩展名*/
    getFileExtension(filePath) {
      if (!filePath) return '';
      const arr = filePath.split(".");
      return arr.length > 1 ? arr.pop() : '';
    },

    /*图片列表变化事件*/
    onImageListChange() {
      // 可以在这里添加图片列表变化后的处理逻辑
      console.log('图片列表已更新', this.form.image);
    }
  }
};
</script>

<style scoped>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.image-item-container {
  margin: 5px;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
  text-align: center;
  cursor: pointer;
  z-index: 10;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .img-select {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
  cursor: pointer;
  color: #909399;
}

.draggable-list .img-select:hover {
  border-color: #409eff;
  color: #409eff;
}

.draggable-list .img-select i {
  margin-bottom: 5px;
}

.upload-text {
  font-size: 12px;
}

/* 表单提示信息 */
.form-hint {
  margin-top: 5px;
  font-size: 12px;
  color: #8392a5;
}

/* 动画效果 */
.fade-list-move {
  transition: transform 0.3s;
}

.max-w460 {
  max-width: 460px;
}

.pb50 {
  padding-bottom: 50px;
}

.common-form {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.common-button-wrapper {
  text-align: center;
  margin-top: 30px;
}

/* 富文本编辑器样式调整 */
.edit_container >>> .edui-editor {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}

.edit_container >>> .edui-editor-toolbar {
  background: #f5f7fa;
  border-bottom: 1px solid #DCDFE6;
}

.edit_container >>> .edui-editor-iframewrapper {
  border: none;
}

/* 简介输入框样式调整 */
.el-textarea {
  max-width: 460px;
}

.el-textarea >>> .el-textarea__inner {
  resize: vertical;
  min-height: 60px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/course_course/studymenu/part/edit.vue